import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withLocationWrapper } from '../../utils/HOC_LocationWrapper';
import * as adsActions from '../../store/ads/actions';

class BackgroundSkin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      impressionTracked: false,
    };

    this.onAdLoad = this.onAdLoad.bind(this);
    this.onAdClick = this.onAdClick.bind(this);
  }

  componentDidMount() {
    this.onAdLoad();
  }

  componentDidUpdate() {
    this.onAdLoad();
  }

  onAdLoad() {
    const {
      trackAdInternal,
      trackAdThirdParty,
      backgroundSkin,
      location,
    } = this.props;
    if (!this.state.impressionTracked && backgroundSkin) {
      this.setState({ impressionTracked: true }, () => {
        trackAdInternal(
          location.pathname,
          'BACKGROUND_SKIN_VIEWED',
          backgroundSkin
        );
        if (backgroundSkin.impressionTrackingURI) {
          trackAdThirdParty(
            location.pathname,
            'BACKGROUND_SKIN_VIEWED',
            backgroundSkin.impressionTrackingURI
          );
        }
      });
    }
  }

  onAdClick(event) {
    event.preventDefault();
    const {
      trackAdInternal,
      trackAdThirdParty,
      backgroundSkin,
      location,
    } = this.props;
    const { externalLink, clickTrackingURI } = backgroundSkin;
    if (backgroundSkin && externalLink) {
      trackAdInternal(
        location.pathname,
        'BACKGROUND_SKIN_CLICKED',
        backgroundSkin
      );
      if (clickTrackingURI) {
        trackAdThirdParty(
          location.pathname,
          'BACKGROUND_SKIN_CLICKED',
          clickTrackingURI
        );
      }
      if (externalLink) window.open(externalLink, 'funbrainLinkOut');
    }
  }

  render() {
    if (!this.props.backgroundSkin) return null;
    const {
      id,
      imageURI,
      externalLink,
      backgroundColor,
    } = this.props.backgroundSkin;
    const style = { backgroundImage: `url(${imageURI})` };
    if (backgroundColor) style.backgroundColor = backgroundColor;
    return (
      <div
        className={`Page__background-skin Page__background-skin--${id} ${
          externalLink ? ' has-link' : ''
        }`}
        onClick={e => this.onAdClick(e)}
        style={style}
      />
    );
  }
}

const BackgroundSkinComponent = connect(false, adsActions)(BackgroundSkin);

export default withLocationWrapper(BackgroundSkinComponent);
